import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types";

const pathBase = `/medical-service-provider/:user_id/status`;

export type IPathBaseParam = IExtractApiParams<typeof pathBase>;

export const status = {
  put: (params: IPathBaseParam) => generateApiPath(pathBase, params),
};
